const getStorage = (storageType) => {
  if (storageType === 'LOCAL_STORAGE') {
    return window.localStorage;
  }
  if (storageType === 'SESSION_STORAGE') {
    return window.sessionStorage;
  }
  throw new Error('unknown storage type');
};

export default getStorage;

// Storage Types
export const LOCAL_STORAGE = 'LOCAL_STORAGE';
export const SESSION_STORAGE = 'SESSION_STORAGE';
